
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Product } from '@/models/jobDetailed';
import ProductsModelComboboxField from '@/components/fields/ProductsModelComboboxField.vue';
import ProductsDescriptionTextField from '@/components/fields/ProductsDescriptionTextField.vue';
import ProductsSerialTextField from '@/components/fields/ProductsSerialTextField.vue';
import ProductsQuantityNumberField from '@/components/fields/ProductsQuantityNumberField.vue';
import ProductsGoodsTypeAutocompleteField from '@/components/fields/ProductsGoodsTypeAutocompleteField.vue';
import ProductsCommonNumberField from '@/components/fields/ProductsCommonNumberField.vue';
import { ProductTypeItem } from '@/store/modules/staticData/staticDataTypes';
import LegsBlockBtn from '@/components/btns/LegsBlockBtn.vue';
import LegsSmallRoundBtn from '@/components/btns/LegsSmallRoundBtn.vue';
import store from '@/store';
import _uniqueId from 'lodash/uniqueId';

@Component({
  components: {
    ProductsModelComboboxField,
    ProductsDescriptionTextField,
    ProductsSerialTextField,
    ProductsQuantityNumberField,
    ProductsGoodsTypeAutocompleteField,
    ProductsCommonNumberField,
    LegsBlockBtn,
    LegsSmallRoundBtn,
  },
})
export default class ProductsFieldset extends Vue {
  @Prop(Array) public value: Product[];
  @Prop(Number) public deliveryStopNumber: number;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get pickupProducts(): Product[] {
    return this.value;
  }

  set pickupProducts(value) {
    // console.debug('set pickupProducts');
    this.$emit('input', value);
  }

  public handleDelClick(_clientId: string) {
    // console.debug('handleDelClick', index);
    this.pickupProducts = this.pickupProducts.filter(pickupProduct => pickupProduct._clientId !== _clientId);
  }

  public defaultGoodsTypeItem: ProductTypeItem;
  public defaultGoodsTypeValue = 'PCL';

  public handleAddClick() {
    const pickupProduct = {
      model: '',
      model_id: -1,
      description: '',
      serial: '',
      delivery_stop_number: this.deliveryStopNumber,
      ...this.getPickupProductParams(this.defaultGoodsTypeItem),
      pieces: 1,
      type_code: this.defaultGoodsTypeValue,
      primary_service: '', // TODO
      // quant_id: null,
      volume: '',
      _clientId: _uniqueId(),
      extra_options: null,
    };
    this.pickupProducts = [...this.pickupProducts, pickupProduct];
  }

  public getPickupProductParams(goodsTypeItem: ProductTypeItem) {
    return {
      weight: Number(Math.ceil(parseFloat(String(goodsTypeItem.weight)))),
      length: goodsTypeItem.default_length,
      width: goodsTypeItem.default_width,
      height: goodsTypeItem.default_height,
    };
  }

  private async created() {
    const items: ProductTypeItem[] = await store.getters['moduleStaticData/getAllStaticData'].productTypes;
    this.defaultGoodsTypeItem = items.find(item => item.code === this.defaultGoodsTypeValue) || {
      code: this.defaultGoodsTypeValue,
      description: '',
      weight: 0,
      default_length: 0,
      default_width: 0,
      default_height: 0,
    };
  }

  public handleGoodsTypeChange(goodsTypeItem: ProductTypeItem | null, index: number) {
    if (goodsTypeItem) {
      Object.assign(this.pickupProducts[index], {
        ...this.pickupProducts[index],
        ...this.getPickupProductParams(goodsTypeItem),
      });
    }
  }
}
